import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { lazy, Suspense } from "react";
import AnalyticsTracker from "../componentes/AnalyticsTracker";
import { TIPOS_LANDING } from "../config/tiposLanding";

// Componente de carga
const LoadingFallback = () => (
  <div className="min-h-screen flex items-center justify-center bg-main-light dark:bg-main-dark">
    <div className="text-center">
      <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      <p className="mt-4 text-gray-600 dark:text-gray-400">Cargando...</p>
    </div>
  </div>
);

// Lazy loading de componentes públicos
const Layout = lazy(() => import("./Layout"));
const Alquiler = lazy(() => import("../componentes/Alquiler"));
const Details = lazy(() => import("../componentes/Details"));
const Venta = lazy(() => import("../componentes/Venta"));
const TipoListado = lazy(() => import("../componentes/TipoListado"));
const Home = lazy(() => import("../componentes/NewHome"));
const Servicios = lazy(() => import("../componentes/Servicios"));
const Nosotros = lazy(() => import("../componentes/Nosotros"));
const Contacto = lazy(() => import("../componentes/Contacto"));
const Administración = lazy(() => import("../componentes/Administracion"));

// Lazy loading de componentes admin
const AdminLogin = lazy(() => import("../componentes/AdminLogin"));
const AdminPanelLayout = lazy(() => import("../componentes/AdminPanelLayout"));
const AdminDashboard = lazy(() => import("../componentes/AdminDashboard"));
const AdminUploadProperty = lazy(
  () => import("../componentes/AdminUploadProperty"),
);
const AdminProperties = lazy(() => import("../componentes/AdminProperties"));
const AdminRentals = lazy(() => import("../componentes/AdminRentals"));
const AdminSales = lazy(() => import("../componentes/AdminSales"));
const AdminSettings = lazy(() => import("../componentes/AdminSettings"));
const AdminPropertyDetail = lazy(
  () => import("../componentes/AdminPropertyDetail"),
);
const AdminEditProperty = lazy(
  () => import("../componentes/AdminEditProperty"),
);

// Componente para proteger rutas
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("adminToken");
  return token ? children : <Navigate to="/admin-login" replace />;
};

const Rutas = () => {
  return (
    <BrowserRouter>
      <AnalyticsTracker />
      <Suspense fallback={<LoadingFallback />}>
        <Routes>
          {/* Admin Routes */}
          <Route path="/admin-login" element={<AdminLogin />} />

          <Route
            path="/admin-panel/*"
            element={
              <ProtectedRoute>
                <AdminPanelLayout />
              </ProtectedRoute>
            }
          >
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="properties" element={<AdminProperties />} />
            <Route path="properties/:id" element={<AdminPropertyDetail />} />
            <Route path="upload-property" element={<AdminUploadProperty />} />
            <Route path="edit-property/:id" element={<AdminEditProperty />} />
            <Route path="rentals" element={<AdminRentals />} />
            <Route path="sales" element={<AdminSales />} />
            <Route path="settings" element={<AdminSettings />} />
          </Route>

          {/* Public Routes */}
          <Route path="/" element={<Layout />}>
            <Route exact path={"/"} element={<Home />} />
            <Route exact path={"/Servicios"} element={<Servicios />} />
            <Route exact path={"/Nosotros"} element={<Nosotros />} />
            <Route exact path={"/Contacto"} element={<Contacto />} />
            <Route exact path={"/Alquiler"} element={<Alquiler />} />
            <Route exact path={"/Venta"} element={<Venta />} />
            {/* Landing por tipo: /Venta/casas, /Alquiler/locales-comerciales.
                Van antes de /:id y ademas React Router prioriza los segmentos
                estaticos sobre los dinamicos, asi que /Venta/19 sigue cayendo
                en Details y /Venta/casas en la landing. */}
            {TIPOS_LANDING.flatMap((t) =>
              ["Venta", "Alquiler"].map((operacion) => (
                <Route
                  key={`${operacion}-${t.slug}`}
                  path={`/${operacion}/${t.slug}`}
                  element={<TipoListado operacion={operacion} slug={t.slug} />}
                />
              )),
            )}

            <Route exact path={"/Venta/:id"} element={<Details />} />
            <Route exact path={"/Alquiler/:id"} element={<Details />} />
            <Route
              exact
              path={"/Administracion"}
              element={<Administración />}
            />
          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};

export default Rutas;
